/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from '../../../message';
import { IDescriptorBody } from '../../../descriptor';

export interface IUpdateCommentThreadMessage extends IMessage {
	commentThreadId: string;
	documentId: string;
	context: string | null | undefined;
	attributes: string | null;
	unlinkedAt: string | null;
}

export default class UpdateCommentThreadMessage extends Message {
	public readonly unlinkedAt: Date | string;

	public static readonly TYPE: string = '143';

	public static readonly READABLE_TYPE_NAME: string = 'updateCommentThread';

	public static readonly DESCRIPTOR_NAME: string = 'CommentsV2UpdateCommentThreadMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			commentThreadId: {
				type: 'string',
				id: 1
			},
			documentId: {
				type: 'string',
				id: 2
			},
			context: {
				type: 'string',
				id: 3
			},
			attributes: {
				type: 'string',
				id: 4
			},
			unlinkedAt: {
				type: 'string',
				id: 5
			}
		}
	};

	public constructor(
		public readonly commentThreadId: string,
		public readonly documentId: string,
		public readonly context?: Record<string, unknown> | null,
		public readonly attributes: Record<string, unknown> | null = null,
		unlinkedAt: string | Date | null = null
	) {
		super();

		this.unlinkedAt = unlinkedAt ? new Date( unlinkedAt ) : '';
	}

	public toJSON(): IUpdateCommentThreadMessage {
		return {
			documentId: this.documentId,
			commentThreadId: this.commentThreadId,
			context: this.context ? JSON.stringify( this.context ) : this.context,
			attributes: this.attributes ? JSON.stringify( this.attributes ) : null,
			// instanceof operator can be safely used on node constructors e.g Date
			/* eslint-disable no-restricted-syntax */
			unlinkedAt: this.unlinkedAt instanceof Date ? this.unlinkedAt.toISOString() : this.unlinkedAt
		};
	}

	public static fromJSON( object: IUpdateCommentThreadMessage ): UpdateCommentThreadMessage {
		return new UpdateCommentThreadMessage(
			object.commentThreadId,
			object.documentId,
			object.context ? JSON.parse( object.context ) : object.context,
			object.attributes ? JSON.parse( object.attributes ) : null,
			object.unlinkedAt ? new Date( object.unlinkedAt ) : null
		);
	}
}
